export const setSession = (token, user) => {
    localStorage.clear();
    localStorage.setItem('auth', token.authorization);
    localStorage.setItem('user', JSON.stringify(user));
};

export const setSessionUpdateUser = (user) => {
    localStorage.setItem('user', JSON.stringify(user));
};